import {Outlet } from "react-router-dom";
import Sidebar, { LinkSection } from "./sidebar";
import styles from "./styles.module.scss";
import Appbar from "./appbar";
import { useState, ReactNode } from "react";
import { AppBarTitleContextProvider } from "./appbar/Title/context";

export default function AdminLayout({
  SidebarLinkSections = [],
  SidebarHeader,
  hideSidebar = false,
  children,
}: {
  SidebarLinkSections?: LinkSection[];
  SidebarHeader?: ReactNode;
  hideSidebar?: boolean;
  showBackButton?: boolean;
  children?: ReactNode;
}) {

  const [menuVisible, setMenuVisible] = useState(false);
  const [menuSize, setMenuSize] = useState<'large' | 'small'>('large');

  return (
    <AppBarTitleContextProvider>
      <>
        <Appbar
          onPressOpenMenu={hideSidebar ? undefined : () => setMenuVisible(true)}
          onPressChangeMenuSize={hideSidebar ? undefined : () => setMenuSize(menuSize === 'large' ? 'small' : 'large')}
        />
        <div className={hideSidebar ? styles.fullWidthContainer : styles.sidebarAndContentContainer}>
          {!hideSidebar && (
            <Sidebar
              linkSections={SidebarLinkSections}
              header={SidebarHeader}
              onPressCloseMenu={() => setMenuVisible(false)}
              visible={menuVisible}
              size={menuSize}
            />
          )}
          <div className={styles.contentContainer} style={{ paddingTop: 70 }}>
            {children || <Outlet />}
          </div>
        </div>
      </>
    </AppBarTitleContextProvider>
  );
}